import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { financialForensicsConstants } from '../../../core-utils/messages/financialForensicsConstants';
import React from 'react';
import { CardComponent } from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import EmployeeCountTable from '../../molecules/EmployeeCountTable';
import { EmployeeCount as EmployeeCountDataType } from '../../../pages/FinancialForensicsPage/types/EmployeeCount.types';
import {
  formatColumnsforEmployeeCountTable,
  formatEmployeeCountTableData,
} from '../../../core-utils/helper-utils/financialForensics/employeeCountHelper';

type EmployeeCountType = {
  employeeCountData: EmployeeCountDataType;
  setEmployeeCountModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  handleAddEmployeeDetails: any;
  isMainPage: boolean;
};
const EmployeeCount: React.FC<EmployeeCountType> = ({
  employeeCountData,
  setEmployeeCountModalOpen,
  handleAddEmployeeDetails,
  isMainPage = true,
}) => {
  const { classes } = makeStyles()({
    contentContainer: {
      marginTop: '1rem',
      display: 'flex',
      flexDirection: 'column',
      gap: '1rem',
    },
  })();
  const messages = financialForensicsConstants;
  return (
    <Grid className={classes.contentContainer}>
      <CardComponent
        title={
          (isMainPage ? 'Projected ' : '') + messages.employeeCount.countTitle
        }
        body={
          <EmployeeCountTable
            columns={formatColumnsforEmployeeCountTable(
              employeeCountData,
              'count',
            )}
            headerRowColor="#559294"
            tableTitle={messages.employeeCountTable.countTitle}
            rowsData={formatEmployeeCountTableData(employeeCountData, 'count')}
            handleOnClick={() => {
              handleAddEmployeeDetails('count');
              setEmployeeCountModalOpen(true);
            }}
          />
        }
      />
      <CardComponent
        title={
          (isMainPage ? 'Projected ' : '') +
          messages.employeeCount.subscriptionTitle
        }
        body={
          <EmployeeCountTable
            columns={formatColumnsforEmployeeCountTable(
              employeeCountData,
              'subscription',
            )}
            headerRowColor="#BE8661"
            tableTitle={messages.employeeCountTable.subscriptionTitle}
            rowsData={formatEmployeeCountTableData(
              employeeCountData,
              'subscription',
            )}
            handleOnClick={() => {
              handleAddEmployeeDetails('subscription');
              setEmployeeCountModalOpen(true);
            }}
          />
        }
      />
      <CardComponent
        title={
          (isMainPage ? 'Projected ' : '') + messages.employeeCount.planTitle
        }
        body={
          <EmployeeCountTable
            columns={formatColumnsforEmployeeCountTable(
              employeeCountData,
              'plan',
            )}
            headerRowColor="#BE8661"
            tableTitle={messages.employeeCountTable.planTitle}
            rowsData={formatEmployeeCountTableData(employeeCountData, 'plan')}
            handleOnClick={() => {
              handleAddEmployeeDetails('plan');
              setEmployeeCountModalOpen(true);
            }}
          />
        }
      />
    </Grid>
  );
};

export default EmployeeCount;
